import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import './Profile.css';

const Profile = () => {
  const navigate = useNavigate();
  const { user, getCurrentUser } = useAuth();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadUserProfile();
  }, []);

  const loadUserProfile = async () => {
    setLoading(true);
    try {
      await getCurrentUser();
    } catch (error) {
      console.error('获取用户信息失败:', error);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '未知';
    const date = new Date(dateString);
    return date.toLocaleString('zh-CN', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  const getInitials = () => {
    if (user?.username) {
      return user.username.charAt(0).toUpperCase();
    }
    return 'U';
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>加载中...</p>
      </div>
    );
  }

  return (
    <div className="profile-container">
      <div className="profile-card">
        <button className="back-btn" onClick={() => navigate(-1)}>
          ← 返回
        </button>

        <div className="profile-header">
          <div className="profile-avatar-large">{getInitials()}</div>
          <h2 className="profile-title">个人资料</h2>
        </div>

        <div className="profile-info">
          <div className="info-item">
            <label>用户名</label>
            <div className="info-value">{user?.username || '未知'}</div>
          </div>

          <div className="info-item">
            <label>邮箱地址</label>
            <div className="info-value">{user?.email || '未知'}</div>
          </div>

          <div className="info-item">
            <label>注册时间</label>
            <div className="info-value">{formatDate(user?.created_at)}</div>
          </div>

          <div className="info-item">
            <label>最后登录</label>
            <div className="info-value">{formatDate(user?.last_login)}</div>
          </div>

          <div className="info-item">
            <label>账户状态</label>
            <div className="info-value">
              <span className="status-badge active">已激活</span>
            </div>
          </div>
        </div>

        <div className="profile-actions">
          <button 
            className="action-btn"
            onClick={() => navigate('/settings')}
          >
            编辑账户设置
          </button>
          <button 
            className="action-btn secondary"
            onClick={() => navigate('/change-password')}
          >
            修改密码
          </button>
        </div>
      </div>
    </div>
  );
};

export default Profile;
